import { Component, Input } from '@angular/core';
import { CaseViewEvent } from '../../../../domain';

@Component({
  selector: 'ccd-event-log-details',
  template: require('./event-log-details.component.html'),
  styles: [require('./event-log-details.scss')]
})
export class EventLogDetailsComponent {
  @Input()
  event: CaseViewEvent;
}
